import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as subrecipients from '../../subrecipients'

export const RESOURCE = {
  payload: {
    description:
      'An external entity receiving a portion of a research award, by a subaward, to assist in project-related work.',
    dimension: subrecipients.RESOURCE.payload,
    level: 0,
    name: 'Subrecipient',
    partialId: PartialId.Standard.create('subrecip'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
